// react
import { SyntheticEvent, useContext, useEffect, useMemo, useState } from 'react';

// router
import { Outlet, Link as RouterLink, useLocation, useSearchParams } from 'react-router-dom';

// i18n
import { useTranslation } from 'react-i18next';

// context
import {
	ContextContracts,
	ContextProject,
	ContextUserProjectPermissions,
} from '../Project.context';

// mui
import { Container, Grid, Typography } from '@mui/material';

// dialogs
import { DialogAddContract } from '../../../dialogs/DialogAddContract/DialogAddContract';

// ui
import { Tabs } from '../../../ui/Tabs/Tabs';

// config
import { featureFlags } from '../../../../config/featureFlags';

export const Contracts = () => {
	// hooks
	const { t } = useTranslation();
	const location = useLocation();
	const [searchParams, setSearchParams] = useSearchParams();

	// params
	const paramDialog = searchParams.get('dialog');

	// context
	const { refetchContracts } = useContext(ContextContracts);
	const { project } = useContext(ContextProject);
	const { userProjectPermissions } = useContext(ContextUserProjectPermissions);

	// defaults
	const defaultTabValue = useMemo(() => {
		if (location.pathname.includes('invoices')) {
			return 'invoices';
		}
		return 'details';
	}, [location]);

	// state
	const [tabValue, setTabValue] = useState(defaultTabValue);

	// vars
	const urlBase = `/project/${project?.idWbg}/contracts`;
	const tabs = [
		{
			component: RouterLink,
			label: t('details'),
			to: `${urlBase}/details`,
			value: 'details',
		},
	];

	if (featureFlags['CONTRACT_WORKFLOW'] && userProjectPermissions?.invoice?.read) {
		tabs.push({
			component: RouterLink,
			label: t('invoices'),
			to: `${urlBase}/invoices`,
			value: 'invoices',
		});
	}

	// handlers
	const handleChangeTab = (e: SyntheticEvent, value: string) => {
		setTabValue(value);
	};

	const handleCloseDialog = () => {
		setSearchParams((params) => {
			params.delete('dialog');
			return params;
		});
	};

	// set active tab
	useEffect(() => {
		const tabValueByLocation = location.pathname.includes('invoices') ? 'invoices' : 'details';
		setTabValue(tabValueByLocation);
	}, [location]);

	return (
		<>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Container maxWidth={false}>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<Typography variant="h2">{t('contracts')}</Typography>
							</Grid>
						</Grid>
					</Container>
				</Grid>
				<Grid item xs={12}>
					<Tabs hasBorder={false} onChange={handleChangeTab} tabs={tabs} value={tabValue} />
				</Grid>
				<Grid item xs={12}>
					<Outlet />
				</Grid>
			</Grid>
			<DialogAddContract
				isOpen={paramDialog === 'addContract'}
				onClose={handleCloseDialog}
				onSuccess={() => {
					refetchContracts();
				}}
			/>
		</>
	);
};
